import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d0c85e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-16" }
const _hoisted_2 = { class: "mb-12 layout-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { useReturnRoute } from '@/composables/useReturnRoute';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { getReturnRoute } = useReturnRoute();

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_BalBtn, {
        tag: "router-link",
        to: _unref(getReturnRoute)(),
        color: "white",
        circle: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BalIcon, {
            name: "x",
            size: "lg"
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_router_view, {
      key: _ctx.$route.path
    })
  ]))
}
}

})